import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { isDTS } from "../utility/platform";

export const COIN_MODES = { GOLD: "gc_balance", DREAM: "dc_general" };
export const addFundingBucket = (bets, coinMode) =>
  (Array.isArray(bets) ? bets : []).map((bet) =>
    Array.isArray(bet)
      ? bet.map((leg) => ({ ...leg, fundingCoinBucket: coinMode }))
      : ({ ...bet, fundingCoinBucket: coinMode })
  );
export const getCoinModeBalance = (wallet = {}, coinMode = COIN_MODES.GOLD) =>
  coinMode === COIN_MODES.DREAM
    ? Number(wallet.unplayed_dc || 0) + Number(wallet.redeemable_dc || 0)
    : Number(wallet.gc_balance || 0);
const STORAGE_KEY = "dts:coin-mode";
const CoinModeContext = createContext(null);

export function CoinModeProvider({ children }) {
  const [coinMode, setCoinModeState] = useState(() => {
    if (!isDTS()) return COIN_MODES.GOLD;
    return window.localStorage.getItem(STORAGE_KEY) === COIN_MODES.DREAM
      ? COIN_MODES.DREAM
      : COIN_MODES.GOLD;
  });

  const setCoinMode = (next) => {
    if (!Object.values(COIN_MODES).includes(next)) return;
    setCoinModeState(next);
    window.localStorage.setItem(STORAGE_KEY, next);
  };

  useEffect(() => {
    if (!isDTS()) return;
    document.documentElement.dataset.coinMode = coinMode;
    return () => delete document.documentElement.dataset.coinMode;
  }, [coinMode]);

  const value = useMemo(() => ({ coinMode, setCoinMode }), [coinMode]);
  return <CoinModeContext.Provider value={value}>{children}</CoinModeContext.Provider>;
}

export const useCoinMode = () => {
  const value = useContext(CoinModeContext);
  if (!value) throw new Error("useCoinMode must be used within CoinModeProvider");
  return value;
};
